import React, { Fragment, Component, useState, useEffect } from "react";
import Modal from "react-modal";
import Parse from "html-react-parser";
import WelcomePageSchema from "./data/pageSchema";
import _ from "underscore";
import { connect, useDispatch, useSelector } from "react-redux";
import { change } from "redux-form";
import "./index.scss";
import FormBuilder from "./formBuilder";
import { updateUserData } from "./actions/actions_updateUsers";
import { fetchUserData } from "../../global/app/actions/actions_fetchUsers";
import { store } from "../../global/app/store";
import { C } from "@styled-icons/fa-solid";

Modal.setAppElement("#root");
function WelcomeModal(props) {
  const dispatch = useDispatch();
  const welcomeModalState = useSelector((state) => state.form.WelcomeModal);
  const currentUser = useSelector((state) => state.appReducer.userDataReducer.data);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalpages, setTotalPages] = useState(WelcomePageSchema.length);
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
    store.dispatch(fetchUserData());
  };

  const userHasReqFiledValues = () => {
    return currentUser.accepted_rules_of_behavior ? false : true;
  }

  useEffect(() => {
    setShowModal(userHasReqFiledValues());
  }, []);

  const isLasetPage = (currntPage) => {
    if (currntPage === totalpages - 1) {
      return true;
    }
    return false;
  }

  const handleFormSubmit = (collection) => {
    dispatch(updateUserData(collection));
  }

  const handleNext = (currentPage) => {
    let thisPage = currentPage + 1;
    if (thisPage < totalpages) {
      setCurrentPage(thisPage);
    }
    if (thisPage === 3 && currentUser) {
      dispatch(change("WelcomeModal", "email_address", currentUser.email));
    }
    if (isLasetPage(thisPage)) {
      if (welcomeModalState && _.isUndefined(welcomeModalState.syncErrors)) {
        let collection = _.omit(
          welcomeModalState?.values,
          "acknowledgement"
        );
       handleFormSubmit(collection);
      }
    }
  }

  const handleBack = (currentPage) => {
    if (currentPage !== 0) {
      setCurrentPage(currentPage - 1);
    }
  }

  const getPageData = (n) => {
    return WelcomePageSchema.map((p) => p).filter((p) => p.id === n);
  }

  const disableNext = (currentPage) => {
    switch (currentPage) {
      case 0:
        return false;
      case 1:
        if (
          _.isUndefined(welcomeModalState?.values) ||
          !welcomeModalState?.values?.acknowledgement
        ) {
          return true;
        }
        break;
      case 2:
        if (
          _.isUndefined(welcomeModalState?.values) ||
          !welcomeModalState?.values?.account_type
        ) {
          return true;
        }
        break;
      case 3:
        var requiredProps = [
          "email_address",
          "last_name",
          "first_name",
          "phone_number",
          "legal_business_name",
        ];
        var inBoth = _.intersection(
          _.keys(welcomeModalState?.values),
          requiredProps
        );
        if (
          inBoth.length !== requiredProps.length ||
          !_.isUndefined(welcomeModalState.syncErrors)
        ) {
          return true;
        }
        break;
      default:
        return false;
    }
  }

  const getCounter = (page_id) => {
    let counter = WelcomePageSchema.map((p, n) => {
      return (
        <li key={n}>
          <i
            style={{ color: page_id === n ? "#0071bc" : "#e8e8e8" }}
            className="fa fa-circle"
          />
        </li>
      );
    });
    return counter;
  }

    let thisPage = getPageData(currentPage)[0];
    let btnStyles = {
      visibility: currentPage === 0 ? "hidden" : "visible",
    };

    return (
      <Fragment>
        <Modal
          isOpen={showModal}
          contentLabel="welcomeModal"
          className="Modal modal-welcome"
          overlayClassName="Overlay"
          shouldCloseOnEsc={false}
          shouldCloseOnOverlayClick={false}
        >
          <div id="welcome-modal">
            <div id="welcome-modal_inner">
              <h3>{Parse(thisPage.title)}</h3>
              {Parse(thisPage.description)}
              <div className={`welcome-page welcome-page-body_${thisPage.id}`}>
                {Parse(thisPage.body)}
                {isLasetPage(thisPage.id) && (
                  <button
                    onClick={handleCloseModal}
                    className="usa-button"
                  >
                    Explore FLAG
                  </button>
                )}
                <FormBuilder model={thisPage.model} />
              </div>
            </div>
            <div
              id="page-footer"
              style={{
                display: isLasetPage(thisPage.id) ? "none" : "flex",
              }}
            >
              <div className="item-1">
                <button
                  className="usa-button usa-button--outline"
                  onClick={() => {
                    handleBack(thisPage.id);
                  }}
                  style={btnStyles}
                >
                  Back
                </button>
              </div>
              <div id="stepper" className="item-2">
                <ul className="page-counter">{getCounter(thisPage.id)}</ul>
              </div>
              <div className="item-3">
                <button
                  className="usa-button"
                  disabled={disableNext(thisPage.id)}
                  onClick={() => {
                    handleNext(thisPage.id);
                  }}
                >
                  {thisPage.id === 3 ? "Finish" : "Next"}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
export default WelcomeModal;
